import { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { AuthForm } from '@/components/AuthForm';
import { useAuth } from '@/hooks/useAuth';

export default function Login() {
  const { user, loading } = useAuth();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const returnTo = searchParams.get('returnTo');

  useEffect(() => {
    if (!loading && user && returnTo) {
      navigate(returnTo, { replace: true });
    }
  }, [user, loading, returnTo, navigate]);

  return <AuthForm />;
}
